module.exports = __webpack_public_path__ + "static/media/norwescon.57b129e0.svg";